import {buildRoute} from "@router/RouterUtils";
import {AppRoute} from "@router/RoutingModels";
import Carousel from "@components/Carousel/Carousel";
import BoostCard from "@components/Boost/BoostCard/BoostCard";
import BoostImage from "@assets/images/tmp/boost.png";
import PageSection, {PageSectionProps} from "@components/Page/PageSection";
import React from "react";
import {CmsSection} from "@lib/Cms/CmsModels";

interface BoostsPreviewProps {
    cms: CmsSection;
}

const BoostsPreview = ({cms}: BoostsPreviewProps) => {

    const pageSectionProps: PageSectionProps = {
        title: cms.title,
        description: cms.text,
        link: cms.cta?.[0] ? {
            label: cms.cta[0].title,
            href: cms.cta[0].scope
        } : null
    }

    return (
      <PageSection {...pageSectionProps} bg={cms.options?.bg}>

          <Carousel settings={{
              breakpoints: {
                  425: {slidesPerView: 1.2},
                  768: {slidesPerView: 2.2},
                  1024: {slidesPerView: 3}
              }
          }} withArrows withNav>

              <BoostCard
                  image={BoostImage}
                  categoryName={"Interactive"}
                  title={"Complete the survey"}
                  date={"15 - 31 January 2026"}
                  linkProps={{to: buildRoute(AppRoute.BOOST, {boostId: 1})}}
              />

              <BoostCard
                  image={BoostImage}
                  categoryName={"Educational"}
                  title={"Watch the video"}
                  date={"12 - 14 June 2026"}
                  linkProps={{to: buildRoute(AppRoute.BOOST, {boostId: 2})}}
              />

              <BoostCard
                  image={BoostImage}
                  categoryName={"Special Purchase"}
                  title={"Buy new equipment"}
                  date={"15 March 2026"}
                  linkProps={{to: buildRoute(AppRoute.BOOST, {boostId: 3})}}
              />

              <BoostCard
                  image={BoostImage}
                  categoryName={"Category"}
                  title={"Boost number four"}
                  date={"15 - 16 March 2026"}
                  linkProps={{to: buildRoute(AppRoute.BOOST, {boostId: 4})}}
              />

              <BoostCard
                  image={BoostImage}
                  categoryName={"Category"}
                  title={"Boost number five"}
                  date={"15 - 16 March 2026"}
                  linkProps={{to: buildRoute(AppRoute.BOOST, {boostId: 5})}}
              />

          </Carousel>
      </PageSection>
  );
};

export default BoostsPreview;